module.exports = __webpack_public_path__ + "img/top_add_point_pc.9a4b01a2.jpg";